import { HttpInterceptorFn } from '@angular/common/http';
import { IAuthLogin } from '../interfaces/auth-user.interface';
import { LocalStorageService } from '../services/local-storage.service';
import { inject } from '@angular/core';

// export function bearerTokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
export const bearerTokenInterceptor: HttpInterceptorFn = (req, next) => {
  // console.log('Bearer Token Interceptor, Headers: ', req.headers);
  const localStorageService = inject(LocalStorageService);
  const headerAuthorizationName = 'Authorization';
  const headerValidationName = 'Validation';
  const user: IAuthLogin | null = localStorageService.get<IAuthLogin>('user');
  // console.log('Bearer Token Interceptor, User: ', user);

  if (user) {
    try {
      const token = user?.access_token;
      if (token && !req.headers.has(headerAuthorizationName)) {
        req = req.clone({
          // headers: req.headers.set(headerName, `Bearer ${token}`)
          setHeaders: {
            [headerAuthorizationName]: `Bearer ${token}`,
            [headerValidationName]: 'onelogin'
          }
        });
      }
    } catch (error) {
      console.error('Error parsing user from localStorage: ', error);
    }
  }

  return next(req);
};
